<div class="responsive-container">
  <bpc-generic-listing [tableClass]="'admin-table'" [title]="'Companies'" [shouldShowPagination]="false" [columns]="dataColumns" [data]="users" [totalCount]="totalCount" [isLoading]="isLoading" [companiesFilter]="usersFilters" (onFilterChange)="onFilterChange($event)">
    <div slot="subroutes" class="col flex align-content-center flex-wrap flex-w-auto vote-tab-container">
      <ng-container *ngFor="let ef of childTabs" >
        <a class="vote-tab-buttons" [routerLink]="!isMobile ? '/admin-panel/' + ef.route : '/m/admin-panel/' + ef.route" [ngClass]="{ 'active-ic-vote-tab': type === ef.route }">
          {{ef.label}}
        </a>
      </ng-container>
    </div>
    <div slot="filters" *ngIf="type == ''" class="grid grid-no-tb-gutter flex justify-content-end align-items-center pb-2 pr-3">
      <label style="display: flex; align-items: center; gap: 5px;">
        <input type="checkbox" [(ngModel)]="showAllUsers" />
        Show All Users
      </label>
      <button style="margin-left: 25px" class="button-dark" type="button" pButton (click)="addOrEditUser()">
        Add User
      </button>
    </div>
  </bpc-generic-listing>
</div>
